import React, { useEffect } from "react";
import { Phone, MessageCircle, Sparkles, Star, CheckCircle2, User, Download } from "lucide-react";
import jathakalayaImg from "../assets/Media (2).jfif";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/BannerSections.css";

export function JathakalayaSection() {
  const { i18n } = useTranslation();
  const isTa = i18n.language === "ta";

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="banners-section-wrapper" data-aos="fade-up">
      <div className="custom-banner-card" data-aos="zoom-in">
        
        {/* Card Header Row */}
        <div className="custom-card-header">
          <div className="custom-card-title-group">
            <div className="custom-card-icon-box">
              <Star size={24} fill="currentColor" />
            </div>
            <div>
              <h3 className="custom-card-title">
                {isTa ? "ஐஸ்வர்யா ஜாதகாலயா" : "Aishwarya Jathakalaya"}
              </h3>
              <p className="custom-card-subtitle">
                <User size={14} color="#dc2626" />
                <span>{isTa ? "கே.எஸ்.ரவீந்திரன் - வேத சாஸ்திர ஜோதிடர்" : "K.S. Ravindhran - Vedic Astrologer"}</span>
              </p>
            </div>
          </div>

        
        </div>

        {/* Main Body: CSS Grid (Text Left, Image Right) */}
        <div className="custom-card-body-grid">
          
          {/* LEFT SIDE: Text & Services List */}
          <div className="custom-card-content">
            <h4 className="custom-list-title">
              {isTa ? "சிறப்பு ஆலோசனைகள்:" : "Astrology Services List:"}
            </h4>
            
            <ul className="custom-list">
              <li className="custom-list-item">
                <CheckCircle2 size={16} color="#dc2626" style={{ flexShrink: 0 }} />
                <span>{isTa ? "திருமண ஜாதக பொருத்தம் & துல்லிய கணிப்பு" : "Horoscope Matching & Predictions"}</span>
              </li>
              <li className="custom-list-item">
                <CheckCircle2 size={16} color="#dc2626" style={{ flexShrink: 0 }} />
                <span>{isTa ? "குழந்தை பாக்கியம் & தொழில் விருத்தி ஆலோசனைகள்" : "Career Growth & Family Prosperity"}</span>
              </li>
              <li className="custom-list-item">
                <CheckCircle2 size={16} color="#dc2626" style={{ flexShrink: 0 }} />
                <span>{isTa ? "பரிகார பூஜைகள், வாஸ்து சாஸ்திரம் & கடன் நிவர்த்தி" : "Parihara Poojai, Vasthu & Debt Relief"}</span>
              </li>
            </ul>
          </div>

          {/* RIGHT SIDE: Image with Download Option */}
          <div className="custom-image-wrapper" style={{ flexDirection: 'column', gap: '1rem' }}>
            <div className="custom-image-container">
              <img
                src={jathakalayaImg}
                alt="Aishwarya Jathakalaya"
                className="custom-image"
              />
            </div>
            
            <a 
              href={jathakalayaImg} 
              download="Aishwarya-Jathakalaya.jpg"
              className="custom-btn btn-yellow"
              style={{ width: '100%', maxWidth: '240px', padding: '0.625rem', fontSize: '0.875rem' }}
            >
              <Download size={16} />
              <span>{isTa ? "கார்டை பதிவிறக்கம் செய்ய" : "Download Card"}</span>
            </a>
          </div>

        </div>

      </div>
    </section>
  );
}